import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";
import { authRoutes } from "../../../features/auth/config/authRoutes";
import RouteFallback from "../fallback/RouteFallback";

export default function EmailVerifiedRoute() {
  const location = useLocation();
  const { isAuthenticated, status, user } = useAuth();
  const isEmailVerified = String(user?.emailVerified).toLowerCase() === "true";
  const isProfileComplete = String(user?.completeProfile).toLowerCase() === "true";
  const requiresAccountSelection =
    isEmailVerified &&
    (Boolean(user?.accountSelectionRequired) || !user?.accountId);

  if (status === "booting") return <RouteFallback />;
  if (!isAuthenticated) return <RouteFallback />;

  if (!isEmailVerified) {
    return <Navigate to="/verificar-email" replace />;
  }

  if (requiresAccountSelection) {
    return <Navigate to={authRoutes.selectAccount} replace />;
  }

  if (!isProfileComplete && location.pathname !== authRoutes.completeSignup) {
    return <Navigate to={authRoutes.completeSignup} replace />;
  }

  return <Outlet />;
}
